import { MmdmIntegrationStatus } from "@models/enums/mmdmIntegrationStatus.enum";

export class MmdmIntegrationStatusResult {
    public status: MmdmIntegrationStatus;
    public endTime: Date;

    constructor(plan: any = {}) {
        this.status = plan.status;
        this.endTime = plan.endTime;
    }

    get type() {
        return 'mmdmIntegrationStatusResult';
    }
}
